var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h3',{staticClass:"big-title"},[_vm._v(_vm._s(_vm.ffInfo.title)+">>")]),_c('pre',{staticClass:"content",domProps:{"innerHTML":_vm._s(_vm.ffInfo.body)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }